import Preference, { type PreferenceScopeValue, type ScopeDefaults } from '../Preference';

type ListSidebarDefaults = ScopeDefaults & {
  sortBy?: string
};

export default class ListSidebarPreference extends Preference {
  protected scopeDefaults: ListSidebarDefaults;

  constructor(values: PreferenceScopeValue, scopeName: string, scopeDefaults: ListSidebarDefaults = { __scopes: {} }) {
    super('ListSidebar', values, scopeName, scopeDefaults);
    this.scopeDefaults = scopeDefaults;
  }

  set sortBy(value: string | undefined) {
    this.addIntoScope('sortBy', value);
  }

  get sortBy(): string {
    return (this.getFromScope('sortBy') as string) || this.scopeDefaults.sortBy || '';
  }
}
